import styled from 'styled-components';

type ButtonProps = {
    color: string;
}

export const Button = styled.button<ButtonProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    width: 100%;
    min-height: 44px;
    padding: 0.75rem 1.5rem;

    font-family: 'Inter', sans-serif;
    font-size: 0.9375rem; /* 15px */
    font-weight: 600;
    letter-spacing: 0.025em;
    color: #ffffff;
    text-transform: uppercase;
    text-decoration: none;
    
    border: 0;
    cursor: pointer;
    border-radius: 0.5rem; /* 8px */
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    background-color: ${props => props.color};
    transition: all 0.3s ease-in-out;
    
    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        opacity: 0.95;
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }
    
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    
    @media screen and (max-width: 875px) {
        font-size: 0.8125rem; /* 13px */
        padding: 0.625rem 1.25rem;
        min-height: 40px;
    }
`;